import { call, put, takeLatest } from "redux-saga/effects";
import { LOGOUT_REQUEST } from "../../actionTypes";
// import { postJobApi } from "./api"; // Replace with your actual API file
import AxiosInstance from "../../../services/AxiosInstance";

import { logoutSuccess, logoutFailure } from "./actions";

function* logout(action) {
  console.log("actionggg", action.payload);
  try {
    const response = yield call(() =>
      AxiosInstance().post("/auth/logout")
    );

    console.log("res234", response);
    if (response.data.status) {
      yield put(logoutSuccess(response.data));
    } else {
      yield put(logoutFailure(response.data));
    }
  } catch (error) {
    yield put(logoutFailure({ status: false, message: error.message }));
  }
}

// Watch for POST_JOB_REQUEST action
function* logoutSaga() {
  yield takeLatest(LOGOUT_REQUEST, logout);
}

export default logoutSaga;
